import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack fw-bold mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-6 me-2" }, "Recently Searched:")
], -1)
const _hoisted_3 = { class: "scroll-y mh-200px mh-lg-325px" }
const _hoisted_4 = { class: "d-flex align-items-center mb-5" }
const _hoisted_5 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_6 = { class: "symbol-label bg-light" }
const _hoisted_7 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fs-6 text-gray-800 text-hover-primary fw-bold"
  }, "BoomApp by Keenthemes"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted fw-bold" }, "#45789")
], -1)
const _hoisted_9 = { class: "d-flex align-items-center mb-5" }
const _hoisted_10 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_11 = { class: "symbol-label bg-light" }
const _hoisted_12 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fs-6 text-gray-800 text-hover-primary fw-bold"
  }, "\"Kept API Project Meeting"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted fw-bold" }, "#84050")
], -1)
const _hoisted_14 = { class: "d-flex align-items-center mb-5" }
const _hoisted_15 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_16 = { class: "symbol-label bg-light" }
const _hoisted_17 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fs-6 text-gray-800 text-hover-primary fw-bold"
  }, "\"KPI Monitoring App Launch"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted fw-bold" }, "#84250")
], -1)
const _hoisted_19 = { class: "d-flex align-items-center mb-5" }
const _hoisted_20 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_21 = { class: "symbol-label bg-light" }
const _hoisted_22 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fs-6 text-gray-800 text-hover-primary fw-bold"
  }, "Project Reference FAQ"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted fw-bold" }, "#67945")
], -1)
const _hoisted_24 = { class: "d-flex align-items-center mb-5" }
const _hoisted_25 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_26 = { class: "symbol-label bg-light" }
const _hoisted_27 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fs-6 text-gray-800 text-hover-primary fw-bold"
  }, "\"FitPro App Development"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted fw-bold" }, "#84250")
], -1)
const _hoisted_29 = { class: "d-flex align-items-center mb-5" }
const _hoisted_30 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_31 = { class: "symbol-label bg-light" }
const _hoisted_32 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fs-6 text-gray-800 text-hover-primary fw-bold"
  }, "Shopix Mobile App"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted fw-bold" }, "#45690")
], -1)
const _hoisted_34 = { class: "d-flex align-items-center mb-5" }
const _hoisted_35 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_36 = { class: "symbol-label bg-light" }
const _hoisted_37 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fs-6 text-gray-800 text-hover-primary fw-bold"
  }, "\"Landing UI Design\" Launch"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted fw-bold" }, "#24005")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/electronics/elc004.svg" })
            ])
          ])
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra001.svg" })
            ])
          ])
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra006.svg" })
            ])
          ])
        ]),
        _hoisted_18
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra002.svg" })
            ])
          ])
        ]),
        _hoisted_23
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com010.svg" })
            ])
          ])
        ]),
        _hoisted_28
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("span", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin001.svg" })
            ])
          ])
        ]),
        _hoisted_33
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("span", _hoisted_36, [
            _createElementVNode("span", _hoisted_37, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra002.svg" })
            ])
          ])
        ]),
        _hoisted_38
      ])
    ])
  ]))
}